import {  movieService } from "../../Service/MovieService";

// ── PHP proxy (bypasses auth) ────────────────────────────────────
async function phpFetch(type, page, size) {
    const res = await fetch(`/movies-public-api.php?type=${type}&page=${page}&size=${size}`);
    const data = await res.json();
    if (!data.success) throw new Error('API error');
    return data; // { content, totalElements, totalPages, number }
}

export const moviesPopular = (page, size) => async (dispatch) => {
    try {
        const data = await phpFetch('popular', page, size);
        dispatch({ type: "POPULAR", payload: data.content });
        return data;
    } catch (error) {
        console.error("moviesPopular error:", error);
        throw error;
    }
};

export const moviesTopRated = (page, size) => async (dispatch) => {
    try {
        const data = await phpFetch('toprated', page, size);
        dispatch({ type: "TOP_RATING", payload: data.content });
        return data;
    } catch (error) {
        console.error("moviesTopRated error:", error);
        throw error;
    }
};

export const moviesNew = (page, size) => async (dispatch) => {
    try {
        const data = await phpFetch('new', page, size);
        dispatch({ type: "NEW", payload: data.content });
        return data;
    } catch (error) {
        console.error("moviesNew error:", error);
        throw error;
    }
};

export const moviesNewUpdate = (page, size) => async (dispatch) => {
    try {
        const data = await phpFetch('newUpdate', page, size);
        dispatch({ type: "NEW_UPDATE", payload: data.content });
        return data;
    } catch (error) {
        console.error("moviesNewUpdate error:", error);
        throw error;
    }
};

export const moviesSlug = (slug) => async (dispatch) => {
    try {
        const res = await movieService.movieDetail(slug);
        console.log(res.data);
        if (res && res.data) {
            dispatch({
                type: "DETAIL_MOVIE",
                payload: res.data,
            });
            return res.data;
        } else {
            console.log("Không có dữ liệu trả về từ API");
            throw new Error('Dữ liệu không hợp lệ');
        }
    } catch (error) {
        console.error("Đã xảy ra lỗi:", error);
        throw error;
    }
};


export const searchMovies = (searchParams) => async (dispatch) => {
    try {
        const res = await movieService.movieSearch(searchParams);
        console.log("searchParams:", searchParams);

        if (res && res.data) {
            dispatch({
                type: "MOVIE_SEARCH",
                payload: res.data,
            });
            return res.data;
        } else {
            console.log("Không có dữ liệu trả về từ API");
            throw new Error('Dữ liệu không hợp lệ');
        }
    } catch (error) {
        console.error("Đã xảy ra lỗi:", error);
        throw error;
    }
};

export const countryMovies = () => async (dispatch) => {
    try {
        const res = await movieService.getAllCountry();
        console.log(res.data);
        if (res && res.data) {
            dispatch({
                type: "COUNTRY",
                payload: res.data,
            });
            return res.data;
        } else {
            console.log("Không có dữ liệu trả về từ API");
            throw new Error('Dữ liệu không hợp lệ');
        }
    } catch (error) {
        console.error("Đã xảy ra lỗi:", error);
        throw error;
    }
};

export const releaseYearMovies = () => async (dispatch) => {
    try {
        const res = await movieService.getAllReleaseYear();
        if (res && res.data) {
            dispatch({
                type: "YEAR",
                payload: res.data,
            });
            return res.data;
        } else {
            console.log("Không có dữ liệu trả về từ API");
            throw new Error('Dữ liệu không hợp lệ');
        }
    } catch (error) {
        console.error("Đã xảy ra lỗi:", error);
        throw error;
    }
};

export const genresMovies = () => async (dispatch) => {
    try {
        const res = await movieService.getAllGenres(1, 1000);
        if (res && res.data) {
            dispatch({
                type: "GENRES",
                payload: res.data,
            });
            return res.data;
        } else {
            console.log("Không có dữ liệu trả về từ API");
            throw new Error('Dữ liệu không hợp lệ');
        }
    } catch (error) {
        console.error("Đã xảy ra lỗi:", error);
        throw error;
    }
};
export const getAllActor = (param) => async (dispatch) => {
    try {
        const res = await movieService.getAllActor(param);
        if (res && res.data) {
            dispatch({
                type: "ACTOR",
                payload: res.data,
            });
            return res.data;
        } else {
            console.log("Không có dữ liệu trả về từ API");
            throw new Error('Dữ liệu không hợp lệ');
        }
    } catch (error) {
        console.error("Đã xảy ra lỗi:", error);
        throw error;
    }
};
export const getAllMovieByActor = (actorId) => async (dispatch) => {
    try {
        const res = await movieService.getAllMovieByActor(actorId);
        if (res && res.data) {
            dispatch({
                type: "MOVIE_ACTOR",
                payload: res.data,
            });
            return res.data;
        } else {
            console.log("Không có dữ liệu trả về từ API");
            throw new Error('Dữ liệu không hợp lệ');
        }
    } catch (error) {
        console.error("Đã xảy ra lỗi:", error);
        throw error;
    }
};

export const getActorById = (actorId) => async (dispatch) => {
    try {
        const res = await movieService.getActorByActorId(actorId);
        if (res && res.data) {
            dispatch({
                type: "MOVIE_ACTOR",
                payload: res.data,
            });
            return res.data;
        } else {
            console.log("Không có dữ liệu trả về từ API");
            throw new Error('Dữ liệu không hợp lệ');
        }
    } catch (error) {
        console.error("Đã xảy ra lỗi:", error);
        throw error;
    }
};

export const getMoviePropose = (genreId,movieId) => async (dispatch) => {
    try {
        const res = await movieService.getMoviePropose(genreId,movieId);
        if (res && res.data) {
            dispatch({
                type: "MOVIE_PROPOSE",
                payload: res.data,
            });
            return res.data;
        } else {
            console.log("Không có dữ liệu trả về từ API");
            throw new Error('Dữ liệu không hợp lệ');
        }
    } catch (error) {
        console.error("Đã xảy ra lỗi:", error);
        throw error;
    }
};